import React from 'react';
import './About.css';

const About = () => {
  return (
   <div className='aboutDiv h-auto w-100% flex flex-col items-center justify-center'>
    <h1 className='font-bold'>About</h1>
    <p>
      This is random player game
    </p>
   </div>
  )
}

export default About
